import { render, staticRenderFns } from "./SelectorTagIdent.vue?vue&type=template&id=3202baf6&"
import script from "./SelectorTagIdent.vue?vue&type=script&lang=js&"
export * from "./SelectorTagIdent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports